export default __webpack_public_path__ + "static/media/notification-warning.9b045ed1.svg";